import { CheckoutSession, OnboardingDetailsRole } from '@nemuru-eng/js-api-client';

import { AutoLoanPaymentMethodAction } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/types/AutoLoanPaymentMethodAction';
import { LoanPaymentMethodAction } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/types/LoanPaymentMethodAction';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { AddCoborrowerDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/AddCoborrower/AddCoborrowerDialog';
import { EditOnBoardingDetailsDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/EditOnBoardingDetails/EditOnBoardingDetailsDialog';
import { EditAutoPaymentMethodDialog } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/components/EditAutoPaymentMethodDialog/EditAutoPaymentMethodDialog';
import { UseDialogProps } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/LoanApplicationActionDialog';

export type PaymentMethodEditAction = AutoLoanPaymentMethodAction | LoanPaymentMethodAction;

interface PaymentMethodEditActionsDialogProps {
  currentAction: PaymentMethodEditAction;
  useDialogProps: UseDialogProps;
  checkoutSession?: CheckoutSession;
  loanPaymentMethodDetailEntity?: LoanPaymentMethodDetailEntity;
  refreshCheckoutSessionAndPaymentMethodEntities: () => Promise<void>;
}

export const PaymentMethodEditActionsDialog = ({
  currentAction,
  useDialogProps,
  checkoutSession,
  loanPaymentMethodDetailEntity,
  refreshCheckoutSessionAndPaymentMethodEntities,
}: PaymentMethodEditActionsDialogProps) => {
  const { opened, setOpened } = useDialogProps;

  return (
    <>
      {currentAction === AutoLoanPaymentMethodAction.EDIT_VEHICLE_DATA && checkoutSession && (
        <EditAutoPaymentMethodDialog
          entryMode="vehicle"
          checkoutSession={checkoutSession}
          opened={opened}
          setOpened={setOpened}
          refreshCheckoutSessionAndPaymentMethodEntities={refreshCheckoutSessionAndPaymentMethodEntities}
        />
      )}
      {currentAction === AutoLoanPaymentMethodAction.EDIT_FINANCING_DETAILS && checkoutSession && (
        <EditAutoPaymentMethodDialog
          entryMode="financing"
          checkoutSession={checkoutSession}
          opened={opened}
          setOpened={setOpened}
          refreshCheckoutSessionAndPaymentMethodEntities={refreshCheckoutSessionAndPaymentMethodEntities}
        />
      )}
      {currentAction === LoanPaymentMethodAction.EDIT_BORROWER && loanPaymentMethodDetailEntity && (
        <EditOnBoardingDetailsDialog
          paymentMethodDetailEntity={loanPaymentMethodDetailEntity}
          role={OnboardingDetailsRole.BORROWER}
          opened={opened}
          setOpened={setOpened}
        />
      )}
      {currentAction === LoanPaymentMethodAction.EDIT_CO_BORROWER && loanPaymentMethodDetailEntity && (
        <EditOnBoardingDetailsDialog
          paymentMethodDetailEntity={loanPaymentMethodDetailEntity}
          role={OnboardingDetailsRole.CO_BORROWER}
          opened={opened}
          setOpened={setOpened}
        />
      )}
      {currentAction === LoanPaymentMethodAction.ADD_CO_BORROWER && loanPaymentMethodDetailEntity && (
        <AddCoborrowerDialog
          paymentMethodDetailEntity={loanPaymentMethodDetailEntity}
          opened={opened}
          setOpened={setOpened}
        />
      )}
    </>
  );
};
